import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'sts-video',
  templateUrl: './video.component.html'
})
export class VideoComponent implements OnInit {

  public videoURL: string;
  @Input()
  set data(vidURL: string) {
    this.videoURL = vidURL;
    this.embed(vidURL);
  }

  public src: any = null;
  public isYouTube = false;
  public isVimeo = false;
  public isDailyMotion = false;
  public useDefaultPlayer = false;
  public hasValidUrl = false;

  constructor(private sanitizer: DomSanitizer) { }

  private embed(url: string): any {
    if (url == null || url === '') {
      return;
    }

    if (url.toLowerCase().endsWith('.mp4')) {
      this.hasValidUrl = true;

      this.useDefaultPlayer = true;
      return;
    }

    let id;

    id = this.detectYoutube(url);
    if (id) {
      this.hasValidUrl = true;
      this.isYouTube = true;
      this.src = this.sanitizer.bypassSecurityTrustResourceUrl(`//www.youtube.com/embed/${id}`);
      return;
    }

    id = this.detectVimeo(url);
    if (id) {
      this.hasValidUrl = true;
      this.isVimeo = true;
      this.src = this.sanitizer.bypassSecurityTrustResourceUrl(`//player.vimeo.com/video/${id}`);
      return;
    }

    id = this.detectDailymotion(url);
    if (id) {
      this.hasValidUrl = true;
      this.isDailyMotion = true;
      this.src = this.sanitizer.bypassSecurityTrustResourceUrl(`//www.dailymotion.com/embed/video/${id}`);
      return;
    }
  }

  private detectVimeo(uri: string): string {
    return (uri.indexOf('vimeo.com') > -1) ? uri.split('/')[3] : null;
  }

  private detectYoutube(uri: string): string {
    if (uri.indexOf('youtube.com') > -1) {
      return uri.split('=')[1];
    }

    if (uri.indexOf('youtu.be') > -1 ) {
      return uri.split('/')[3];
    }

    return null;
  }

  private detectDailymotion(uri: string): string {
    if (uri.indexOf('dailymotion.com') > -1) {
      return uri.split('/')[4].split('_')[0];
    }

    if (uri.indexOf('dai.ly') > -1) {
      return uri.split('/')[3];
    }

    return null;
  }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// ./src/app/lib/video/video.component.ts